export const LOCK_BODY: 'LAYOUT/LOCK_BODY' = 'LAYOUT/LOCK_BODY';
export const UNLOCK_BODY: 'LAYOUT/UNLOCK_BODY' = 'LAYOUT/UNLOCK_BODY';
export const GO_TOP: 'LAYOUT/GO_TOP' = 'LAYOUT/GO_TOP';
